export const ConsultingLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-bone font-manrope">
      {children}
    </div>
  );
};
